<template>
  <v-container class="mb-5" fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <div class="py-4 px-8">
            <h4 class="secondary--text font-weight-bold">
              {{
                $t(
                  'fleet_management.agents.create.labels.create_agent_toolbar_title'
                )
              }}
            </h4>
            <span class="text-caption font-italic">
              {{ $t('general.labels.required') }}
            </span>
          </div>
          <v-divider></v-divider>
          <div v-if="showForm">
            <v-form ref="form" v-model="valid">
              <v-container class="px-8 py-6">
                <v-row>
                  <v-col md="3">
                    <div class="tertiary--text text-body-2">
                      {{
                        $t(
                          'fleet_management.agents.create.labels.create_agent_form_name'
                        )
                      }}
                    </div>
                    <v-text-field
                      id="idEventosNombreCrear"
                      v-model.trim="dataForm.label"
                      filled
                      dense
                      required
                      counter="40"
                      hide-details="auto"
                      :error-messages="errorName"
                      @input="waitAndSearchAnAgent"
                      :rules="nameRules"
                      color="tertiary"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="false" md="3">
                    <div class="tertiary--text text-body-2">
                      {{
                        $t(
                          'fleet_management.agents.create.labels.create_gent_form_scope'
                        )
                      }}
                    </div>
                    <v-autocomplete
                      id="idEventosAlcance"
                      v-model="selectedScope"
                      :items="scopes"
                      hide-details
                      return-object
                      dense
                      filled
                      color="tertiary"
                    >
                      <template v-slot:item="data">
                        <v-list-item__title
                          :id="data.item"
                          class="dropdown-element-style"
                        >
                          {{ data.item }}
                        </v-list-item__title>
                      </template>
                    </v-autocomplete>
                    <span
                      class="v-text-field__details px-3"
                      :style="{
                        color: scopeMessage.color,
                        'font-size': '12px'
                      }"
                      >{{ scopeMessage.text }}</span
                    >
                  </v-col>
                </v-row>
                <v-col md="9" class="pl-0">
                  <v-row
                    :key="index"
                    v-for="(condition, index) in conditionsSelected"
                  >
                    <v-col lg="4" md="4">
                      <div class="tertiary--text text-body-2">
                        {{
                          $t(
                            'fleet_management.agents.create.labels.create_agent_form_condition'
                          )
                        }}
                      </div>
                      <v-autocomplete
                        id="idEventosCondicion"
                        required
                        :items="filterThings(availableConditions[index])"
                        :rules="firstConditionRules"
                        :disabled="
                          firstConditionAndMultipleConditionsSelected(index)
                        "
                        return-object
                        item-text="name"
                        v-model="condition.name"
                        :ref="`select-${index}`"
                        @change="
                          val => {
                            onChange(val, index)
                          }
                        "
                        :filter="filterNormalized"
                        dense
                        filled
                        no-data-text="Condición no encontrada"
                        color="tertiary"
                        @input="conditionInp"
                      >
                        <template v-slot:item="data">
                          <v-list-item__title
                            :id="data.item.domElementId"
                            class="dropdown-element-style"
                          >
                            {{ data.item.name }}
                          </v-list-item__title>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-row
                      v-if="condition.agent !== ''"
                      v-show="showDueUndueComponent"
                    >
                      <v-col cols="12" class="px-6">
                        <component
                          @geofenceEmit="
                            geofences => {
                              geofenceEmit(geofences, index)
                            }
                          "
                          @speedEmit="
                            speed => {
                              speedEmit(speed, index)
                            }
                          "
                          @mainPowerEmit="
                            mainPower => {
                              mainPowerEmit(mainPower, index)
                            }
                          "
                          @fuelCutEmit="
                            fuelCut => {
                              fuelCutEmit(mainPower, index)
                            }
                          "
                          @ignitionStateEmit="
                            ignitionState => {
                              ignitionStateEmit(ignitionState, index)
                            }
                          "
                          @detentionEmit="
                            detention => {
                              detentionEmit(detention, index)
                            }
                          "
                          @batteryLowEmit="
                            battery => {
                              batteryLowEmit(battery, index)
                            }
                          "
                          @ralentiRpmEmit="
                            rpm => {
                              ralentiRpmEmit(rpm, index)
                            }
                          "
                          @fuelConsumptionDeviationEmit="
                            fuel => {
                              fuelConsumptionDeviationEmit(fuel, index)
                            }
                          "
                          @fuelTankEmit="
                            fuel => {
                              fuelTankEmit(fuel, index)
                            }
                          "
                          @temperatureValid="temperatureValid"
                          @temperatureMultiValid="temperatureMultiValid"
                          @engineTemperatureValid="engineTemperatureValid"
                          @rpmExcessiveValid="rpmExcessiveValid"
                          @tempSensor="tempSensorEmit"
                          @tempSensorMulti="tempSensorMulti"
                          @engineTemp="engineTempEmit"
                          @rpmExcessive="
                            rpm => {
                              rpmExcessiveEmit(rpm, index)
                            }
                          "
                          @movementValid="movementValid"
                          @movement="movementEmit"
                          @dueUndueEmit="
                            dueUndue => {
                              dueUndueEmit(dueUndue, index)
                            }
                          "
                          :key="condition.id"
                          v-bind:is="condition.agent"
                          editMode
                        ></component>
                      </v-col>
                    </v-row>
                    <v-col lg="12" md="12" class="d-flex justify-end align-end">
                      <FmButton
                        :id="'idEventosAnadirCondicion'"
                        v-if="
                          conditionsSelected.length < amountConditions &&
                            isCombinable &&
                            conditionsSelected[0].agent !== ''
                        "
                        :color="'tertiary'"
                        @click="addCondition()"
                        :button-text="
                          $t(
                            'fleet_management.agents.create.labels.create_agent_add_condition'
                          )
                        "
                      />
                      <FmButton
                        :id="'idEventosEliminarCondicion'"
                        v-if="index > 0"
                        @click="removeCondition(index)"
                        :button-text="'Eliminar condición'"
                        :type="'close'"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-row>
                  <v-col>
                    <div class="divider-dotted"></div>
                  </v-col>
                </v-row>
                <v-row v-if="!isConditionMovementStartOrLowBattery">
                  <v-col md="6" offset-md="3">
                    <time-limit
                      @timeEmit="timeEmit"
                      editMode
                      :conditions="conditionsForTimeComponent"
                      :contactOff="contactOff"
                    ></time-limit>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <time-restriction @schedulingEmit="scheduling" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="auto">
                    <h4 class="secondary--text">
                      {{
                        $t(
                          'fleet_management.agents.create.labels.create_agent_form_things_title'
                        )
                      }}
                    </h4>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="auto">
                    <span class="tertiary--text text-body-2">
                      {{
                        $t(
                          'fleet_management.agents.create.labels.create_agent_form_title_entity'
                        )
                      }}
                    </span>
                    <v-autocomplete
                      id="idEventosEntidadesCrear"
                      v-model="selectedThings"
                      :rules="selectRules"
                      return-object
                      filled
                      dense
                      :items="allThingsFiltered"
                      multiple
                      chips
                      deletable-chips
                      item-text="info.label"
                      no-data-text="no hay info"
                      :loading="thingsLoading"
                      :disabled="thingsLoading"
                      @input="updateThings"
                      color="tertiary"
                      @change="clearConditions"
                    >
                      <template v-slot:prepend-item>
                        <v-tooltip
                          v-if="allThingsFiltered.length >= 2000"
                          top
                          content-class="secondary white--text text-subtitle-2"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-list-item
                              id="idEventosEntidadesSeleccionarTodoCrear"
                              v-bind="attrs"
                              v-on="on"
                              ripple
                              @click="selectAll()"
                            >
                              <v-list-item-action>
                                <v-icon>
                                  {{ icon }}
                                </v-icon>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>
                                  <span>
                                    {{
                                      $t(
                                        'fleet_management.agents.create.labels.create_agent_form_title_select_all'
                                      )
                                    }}
                                  </span>
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                          <span>{{
                            $t(
                              'fleet_management.agents.alerts.select_all_many_entities'
                            )
                          }}</span>
                          <div class="tooltip-arrow"></div>
                        </v-tooltip>
                        <v-list-item
                          id="idEventosEntidadesSeleccionarTodoCrear"
                          v-else
                          ripple
                          @click="selectAll()"
                        >
                          <v-list-item-action>
                            <v-icon>
                              {{ icon }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{
                                $t(
                                  'fleet_management.agents.create.labels.create_agent_form_title_select_all'
                                )
                              }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                      <template v-slot:item="data" style="max-height: 50px;">
                        <v-checkbox
                          v-model="data.item.checked"
                          :value="data.item.checked"
                        ></v-checkbox>
                        <span
                          :id="data.item.domElementId"
                          @click="data.item.checked = !data.item.checked"
                          class="dropdown-element-style py-6"
                        >
                          {{ data.item.info.label }}
                        </span>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index < 3">
                          <span>{{ item.info.label }}</span>
                        </v-chip>
                        <span
                          v-else-if="index === 3"
                          class="grey--text caption"
                        >
                          (+{{ selectedThings.length - 3 }})
                        </span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-container class="px-8 py-6">
              <v-row>
                <v-col>
                  <hr class="divider-dotted" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <BaseTag
                    assignedTagsDomElementId="idEventosEtiquetas"
                    tagsSelectAllDomElementId="idEventosSeleccionarTodoEtiquetas"
                    tagsSelectIndividualTagDomElementId="idEventosEtiqueta"
                    tagChipDomElementId="idEventosChipEtiqueta"
                    :label="
                      $t(
                        'fleet_management.entities.entity_info.labels.card_field_assigned_tags'
                      )
                    "
                    :tag-entities-type="TagsHelpers.ENTITIE_TYPE.AGENTS"
                    @baseTagChange="value => baseTagEmit(value)"
                    ref="tagsAgentThingRefs"
                  />
                </v-col>
              </v-row>
            </v-container>
            <v-container class="px-8 py-6">
              <v-row>
                <v-col>
                  <hr class="divider-dotted" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <Notifications
                    ref="notificationsCreate"
                    @validNotificationsEmit="
                      valid => {
                        validNotificationsEmit(valid)
                      }
                    "
                    @notificationErrorMessageEmit="
                      message => {
                        notificationErrorMessageEmit(message)
                      }
                    "
                  >
                    <template
                      v-slot:tagsPersonSlot="{
                        tagsPersonIsEmpty,
                        baseTagDataSubmitted
                      }"
                    >
                      <BaseTag
                        :tag-entities-type="TagsHelpers.ENTITIE_TYPE.PERSONS"
                        @baseTagChange="value => baseTagsPersonEmit(value)"
                        @tagsPersonIsEmpty="tagsPersonIsEmpty"
                        :baseTagDataSubmittedFn="baseTagDataSubmitted"
                        :label="''"
                        ref="tagsPersonRefs"
                      /> </template
                  ></Notifications>
                </v-col>
              </v-row>
            </v-container>
            <v-container class="px-8 py-6">
              <v-row>
                <v-col align="end">
                  <div class="d-flex justify-space-between my-7">
                    <v-btn
                      id="idBtnEventosCancelarCreacion"
                      depressed
                      outlined
                      rounded
                      @click="goBack"
                      >{{
                        $t(
                          'fleet_management.agents.create.labels.create_agent_form_cancel_button'
                        )
                      }}</v-btn
                    >
                    <v-btn
                      id="idBtnEventosGuardarCreacion"
                      color="tertiary white--text"
                      depressed
                      :disabled="
                        !validityForm ||
                          cancelSubmit ||
                          !validationsTimeRestriction ||
                          !validNotification ||
                          notificationErrorMessage !== ''
                      "
                      rounded
                      @click="submit"
                      :loading="submitLoading"
                      >{{
                        $t(
                          'fleet_management.agents.create.labels.create_agent_form_accept_button'
                        )
                      }}</v-btn
                    >
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <div v-else class="container">
            <v-row>
              <v-col cols="12">
                <h2 class="secondary--text text-center mt-9">
                  {{ 
                    $t(
                      'fleet_management.agents.create.labels.event_configured_successfully', { label: dataForm.label, count: Object.keys(dataForm.things).length }
                      )
                  }}
                </h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="d-flex justify-center my-8">
                <v-btn
                  outlined="true"
                  color="secondary"
                  rounded
                  :to="{
                    name: 'AgentDetail',
                    params: { id: newAgentId }
                  }"
                  >{{
                    $t(
                      'fleet_management.agents.create.labels.create_agent_form_agent_detail_button'
                    )
                  }}</v-btn
                >
                <v-btn
                  class="ml-2"
                  color="tertiary white--text"
                  rounded
                  :to="{ name: 'Agents' }"
                  >{{
                    $t(
                      'fleet_management.agents.create.labels.create_agent_form_agent_list_button'
                    )
                  }}</v-btn
                >
              </v-col>
            </v-row>
          </div>

          <Dialog
            :showDialog="showDialog"
            :text="dialog.text"
            :closeButtonText="dialog.closeButtonText"
            :submitButtonText="dialog.acceptButtonText"
            :type="dialog.type"
            :loading="dialog.loading"
            :oneButton="dialog.oneButtonDialog"
            :oneButtonText="dialog.oneButtonText"
            @oneButtonAction="cancelDialog"
          >
            <template v-slot:extra-data>
              "{{ repeatAgentName.label }}"
            </template>
          </Dialog>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  AgentsHelpers,
  TagsHelpers,
  GlobalHelpers
} from '@/helpers/mainExports.js'
import { mapGetters } from 'vuex'
import { i18n } from '@leapsight/portal'
import store from '@/store'
import SpeedLimit from '../partials/SpeedLimit'
import GeofenceAgent from '../partials/GeofenceAgent'
import TimeLimit from '../partials/TimeLimit'
import MainPower from '../partials/MainPower.vue'
import FuelCut from '../partials/FuelCut.vue'
import IgnitionState from '../partials/IgnitionState.vue'
import NoReport from '../partials/NoReport.vue'
import Security from '../partials/Security'
import Movement from '../partials/Movement'
import LowBattery from '../partials/LowBattery'
import Ralenti from '../partials/Ralenti'
import FuelConsumptionDeviation from '../partials/FuelConsumptionDeviation'
import FuelCharge from '../partials/FuelCharge'
import DueUndueDriverDoor from '../partials/DueUndueDriverDoor.vue'
import DueUndueCargoGate from '../partials/DueUndueCargoGate.vue'
import DueUndueSemiDetach from '../partials/DueUndueSemiDetach.vue'
import TemperatureSensor from '../partials/TemperatureSensor'
import EngineTemperature from '@/components/agents/partials/EngineTemperature.vue'
import RpmExcessive from '@/components/agents/partials/RpmExcessive.vue'
import TemperatureMultiSensor from '@/components/agents/partials/TemperatureMultiSensor.vue'

import { SvgIcon, firebaseServices } from '@leapsight/styleguide'
import { FirebaseTagNames } from '@leapsight/portal'
import Dialog from '@/components/dialog/Dialog'
import Notifications from '../partials/notifications/Notifications'
import conditions_config from '@/helpers/agents/conditions_config'
import timeRestriction from '../timeRestriction/timeRestriction.vue'
import FmButton from '@/share/components/FmButton.vue'
import BaseTag from '@/components/BaseTag.vue'

export default {
  components: {
    BaseTag,
    FmButton,
    SpeedLimit,
    GeofenceAgent,
    TimeLimit,
    SvgIcon,
    Dialog,
    MainPower,
    FuelCut,
    IgnitionState,
    Notifications,
    NoReport,
    timeRestriction,
    Security,
    Movement,
    LowBattery,
    Ralenti,
    FuelConsumptionDeviation,
    DueUndueDriverDoor,
    DueUndueCargoGate,
    DueUndueSemiDetach,
    TemperatureSensor,
    FuelCharge,
    EngineTemperature,
    RpmExcessive,
    TemperatureMultiSensor
  },
  data() {
    return {
      movementValids: true,
      temperatureValids: true,
      temperatureMultiValids: true,
      engineTemperatureValids: true,
      rpmExcessiveValids: true,
      validNotification: true,
      notificationErrorMessage: '',
      cancelSubmit: false,
      geofenceValid: false,
      amountConditions: 0,
      conditionsList: [],
      showDueUndueComponent: false,
      allConditions: [
        {
          name: 'Exceso de Velocidad',
          component: 'SpeedLimit',
          alias: 'mrn:agent_condition:speed_limit',
          id: 'mrn:agent_condition:speed_limit',
          domElementId: 'idEventosExcesoDeVelocidad'
        },
        {
          name: 'Dentro de Zona',
          component: 'GeofenceAgent',
          id: 'mrn:agent_condition:geofence',
          alias: 'mrn:agent_condition:geofence_in',
          type: 'in',
          domElementId: 'idEventosDentroDeZona'
        },
        {
          name: 'Fuera de Zona',
          component: 'GeofenceAgent',
          alias: 'mrn:agent_condition:geofence_out',
          id: 'mrn:agent_condition:geofence',
          type: 'out',
          domElementId: 'idEventosFueraDeZona'
        },
        {
          name: 'Fuera de Zona',
          component: 'GeofenceAgent',
          alias: 'mrn:agent_condition:geofence_outside_all',
          id: 'mrn:agent_condition:geofence',
          type: 'outside_all',
          domElementId: 'idEventosFueraDeTodasLasZonas'
        },
        {
          name: 'Desconexión de Bateria',
          component: 'MainPower',
          alias: 'mrn:agent_condition:main_power_off',
          id: 'mrn:agent_condition:main_power',
          type: false,
          domElementId: 'idEventosDesconexionDeBateria'
        },
        {
          name: 'Conexión de Bateria',
          component: 'MainPower',
          alias: 'mrn:agent_condition:main_power_on',
          id: 'mrn:agent_condition:main_power',
          type: true,
          domElementId: 'idEventosConexionDeBateria'
        },
        {
          name: 'Combustible Cortado',
          component: 'FuelCut',
          alias: 'mrn:agent_condition:fuel_cut_off',
          id: 'mrn:agent_condition:fuel_cut_off',
          type: true,
          domElementId: 'idEventosCombustibleCortado'
        },
        {
          name: 'Combustible restablecido',
          component: 'FuelCut',
          alias: 'mrn:agent_condition:fuel_cut_off',
          id: 'mrn:agent_condition:fuel_cut_off',
          type: false,
          domElementId: 'idEventosCombustibleRestablecido'
        },
        {
          name: 'En Contacto',
          component: 'ignitionState',
          alias: 'mrn:agent_condition:ignition_on',
          id: 'mrn:agent_condition:ignition',
          type: true,
          domElementId: 'idEventosEnContacto'
        },
        {
          name: 'Sin Contacto',
          component: 'ignitionState',
          alias: 'mrn:agent_condition:ignition_off',
          id: 'mrn:agent_condition:ignition',
          type: false,
          domElementId: 'idEventosSinContacto'
        },
        {
          name: 'Detención Prolongada',
          component: 'detention',
          alias: 'mrn:agent_condition:detention',
          id: 'mrn:agent_condition:detention',
          type: true,
          domElementId: 'idEventosDetencionProlongada'
        },
        {
          name: 'No Reporta',
          component: 'NoReport',
          alias: 'mrn:agent_condition:no_report',
          id: 'mrn:agent_condition:no_report',
          type: true,
          domElementId: 'idEventosNoReporta'
        },
        {
          name: 'Pánico',
          component: 'Security',
          alias: 'mrn:agent_condition:panic_button',
          id: 'mrn:agent_condition:panic_button',
          type: true,
          domElementId: 'idEventosPanico'
        },
        {
          name: 'Apertura de lazo',
          component: 'Security',
          alias: 'mrn:agent_condition:lasso_disconnected',
          id: 'mrn:agent_condition:lasso_disconnected',
          type: true,
          domElementId: 'idEventosAperturaDeLazo'
        },
        {
          name: 'Apertura de puerta',
          component: 'DueUndueDriverDoor',
          alias: 'mrn:agent_condition:driver_door',
          id: 'mrn:agent_condition:driver_door',
          type: true,
          domElementId: 'idEventosAperturaDePuerta'
        },
        {
          name: 'Apertura de portón',
          component: 'DueUndueCargoGate',
          alias: 'mrn:agent_condition:cargo_gate',
          id: 'mrn:agent_condition:cargo_gate',
          type: true,
          domElementId: 'idEventosAperturaDePorton'
        },
        {
          name: 'Desenganche',
          component: 'DueUndueSemiDetach',
          alias: 'mrn:agent_condition:semi_detach',
          id: 'mrn:agent_condition:semi_detach',
          type: true,
          domElementId: 'idEventosDesenganche'
        },
        {
          name: 'Antivandálico vulnerado',
          component: 'Security',
          alias: 'mrn:agent_condition:tamper_sensor',
          id: 'mrn:agent_condition:tamper_sensor',
          type: true,
          domElementId: 'idEventosAntivandalicoVulnerado'
        },
        {
          name: 'Inicio de movimiento',
          component: 'Movement',
          alias: 'mrn:agent_condition:movement_start',
          id: 'mrn:agent_condition:movement_start',
          type: true,
          domElementId: 'idEventosInicioDeMovimiento'
        },
        {
          name: 'Batería baja',
          component: 'LowBattery',
          alias: 'mrn:agent_condition:low_battery',
          id: 'mrn:agent_condition:low_battery',
          domElementId: 'idEventosBateriaBaja'
        },
        {
          name: 'Ralenti excesivo',
          component: 'Ralenti',
          alias: 'mrn:agent_condition:ralenti',
          id: 'mrn:agent_condition:ralenti',
          domElementId: 'idEventosRalentiExcesivo'
        },
        {
          name: 'Desvío de combustible',
          component: 'FuelConsumptionDeviation',
          alias: 'mrn:agent_condition:fuel_consumption_deviation',
          id: 'mrn:agent_condition:fuel_consumption_deviation',
          domElementId: 'idEventosDesvioDeCombustible'
        },
        {
          name: 'Sensor de temperatura',
          component: 'TemperatureSensor',
          alias: 'mrn:agent_condition:temperature',
          id: 'mrn:agent_condition:temperature',
          type: true,
          domElementId: 'idEventosSensorDeTemperatura'
        },
        {
          name: 'Sensor de múltiples temperaturas',
          component: 'TemperatureMultiSensor',
          alias: 'mrn:agent_condition:multi_temperature',
          id: 'mrn:agent_condition:multi_temperature',
          type: true,
          domElementId: 'idEventosSensorDeTemperaturaMultiple'
        },
        {
          name: 'Carga de combustible',
          component: 'FuelCharge',
          alias: 'mrn:agent_condition:fuel_charge',
          id: 'mrn:agent_condition:fuel_charge',
          domElementId: 'idEventosCargaDeCombustible'
        },
        {
          name: 'Parada No Autorizada',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_unauthorized_stop',
          id: 'mrn:agent_condition:generic_unauthorized_stop',
          type: true,
          domElementId: 'idEventosParadaNoAutorizada'
        },
        {
          name: 'Puesta en Servicio',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_put_into_service',
          id: 'mrn:agent_condition:generic_put_into_service',
          type: true,
          domElementId: 'idEventosPuestaEnServicio'
        },
        {
          name: 'Quita de Servicio',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_taken_out_of_service',
          id: 'mrn:agent_condition:generic_taken_out_of_service',
          type: true,
          domElementId: 'idEventosQuitaDeServicio'
        },
        {
          name: 'Todavía Desenganchado',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_still_detached',
          id: 'mrn:agent_condition:generic_still_detached',
          type: true,
          domElementId: 'idEventosTodaviaDesenganchado'
        },
        {
          name: 'Evento de prueba',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_event_test',
          id: 'mrn:agent_condition:generic_event_test',
          type: true,
          domElementId: 'idEventosEventoDePrueba'
        },
        {
          name: 'Pasajero detectado',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_seat_passenger',
          id: 'mrn:agent_condition:generic_seat_passenger',
          type: true,
          domElementId: 'idEventosPasajeroDetectado'
        },
        {
          name: 'Entrega',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_delivery',
          id: 'mrn:agent_condition:generic_delivery',
          type: true
        },
        {
          name: 'Giro Brusco',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_sharped_turn',
          id: 'mrn:agent_condition:generic_sharped_turn',
          type: true
        },
        {
          name: 'Frenada Brusca',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_hard_brake',
          id: 'mrn:agent_condition:generic_hard_brake',
          type: true
        },
        {
          name: 'Aceleración Brusca',
          component: 'GenericSensor',
          alias: 'mrn:agent_condition:generic_hard_acceleration',
          id: 'mrn:agent_condition:generic_hard_acceleration',
          type: true
        },
        {
          name: 'Temperatura de motor',
          component: 'EngineTemperature',
          alias: 'mrn:agent_condition:engine_temperature',
          id: 'mrn:agent_condition:engine_temperature',
          type: true
        },
        {
          name: 'RPM excesivo',
          component: 'RpmExcessive',
          alias: 'mrn:agent_condition:excessive_rpm',
          id: 'mrn:agent_condition:excessive_rpm',
          type: true
        }
      ],
      availableConditions: [],
      isCombinable: false,
      conditionsForTimeComponent: [],
      conditionsSelected: [
        {
          name: {},
          agent: '',
          value: {}
        }
      ],
      dataForm: {
        label: '',
        conditions: {},
        window: 0,
        things: {}
      },
      scopes: ['Corporativo', 'Propio'],
      selectedScope: 'Corporativo',
      showForm: true,
      submitLoading: false,
      allThings: [],
      thingsLoading: true,
      selectedThings: [],
      nameRules: [
        v =>
          !!v || i18n.t('fleet_management.agents.create.errors.field_required'),
        v =>
          /[\w+À-ÿñÑ\s]{0,40}([^@;,])$/gi.test(v) ||
          i18n.t('fleet_management.agents.create.errors.invalid_name'),
        v =>
          v.length <= 40 ||
          i18n.t('fleet_management.agents.create.errors.name_length'),
        v =>
          v.length >= 2 ||
          i18n.t('fleet_management.agents.create.errors.name_length')
      ],
      firstConditionRules: [
        v =>
          !!v || i18n.t('fleet_management.agents.create.errors.field_required')
      ],
      agents: [],
      repeatAgentName: '',
      newAgentId: '',
      newAgent: '',
      showDialog: false,
      dialogDefault: {
        text: '',
        closeButtonText: i18n.t('general.dialogComponent.closeButtonText'),
        acceptButtonText: i18n.t('general.dialogComponent.acceptButtonText'),
        type: '',
        loading: false,
        oneButtonDialog: false,
        oneButtonText: ''
      },
      dialog: {
        text: '',
        closeButtonText: i18n.t('general.dialogComponent.closeButtonText'),
        acceptButtonText: i18n.t('general.dialogComponent.acceptButtonText'),
        type: '',
        loading: false,
        oneButtonDialog: false,
        oneButtonText: ''
      },
      valid: true,
      errorName: '',
      setTime: null,
      contactOff: false,
      baseTagsChange: false,
      baseTagsPersonChange: false
    }
  },
  methods: {
    conditionInp() {
      firebaseServices.logEvent(
        firebaseServices.analytics,
        FirebaseTagNames.INP_FLEET_MANAGEMENT_AGENT_CONDITION
      )
    },
    firstConditionAndMultipleConditionsSelected(index) {
      return index === 0 && this.conditionsSelected.length > 1
    },
    baseTagEmit(value) {
      this.baseTagsChange = value
    },
    baseTagsPersonEmit(value) {
      this.baseTagsPersonChange = value
    },
    validNotificationsEmit(valid) {
      this.validNotification = valid
    },
    notificationErrorMessageEmit(valid) {
      this.notificationErrorMessage = valid
    },
    checkServiceForUndue(agent) {
      if (
        agent === 'mrn:agent_condition:driver_door' ||
        agent === 'mrn:agent_condition:driver_door_normal' ||
        agent === 'mrn:agent_condition:semi_detach' ||
        agent === 'mrn:agent_condition:semi_detach_normal' ||
        agent === 'mrn:agent_condition:cargo_gate' ||
        agent === 'mrn:agent_condition:cargo_gate_normal'
      ) {
        const things = this.allThings.filter(thing =>
          thing.config.hasOwnProperty('services')
        )

        const hasBypassAndGarbyConfigService = things.filter(
          thing =>
            Object.keys(thing.config.services).includes(
              'mrn:service:bypass_key'
            ) ||
            Object.keys(thing.config.services).includes(
              'mrn:service:garbi_config'
            )
        )

        this.showDueUndueComponent = Boolean(
          hasBypassAndGarbyConfigService.length
        )
      } else this.showDueUndueComponent = true
    },
    filterThings(thing) {
      const keysServices = [
        'mrn:agent_condition:fuel_cut_off',
        'mrn:agent_condition:driver_door',
        'mrn:agent_condition:driver_door_normal',
        'mrn:agent_condition:panic_button',
        'mrn:agent_condition:lasso_disconnected',
        'mrn:agent_condition:cargo_gate',
        'mrn:agent_condition:semi_detach',
        'mrn:agent_condition:cargo_gate_normal',
        'mrn:agent_condition:semi_detach_normal',
        'mrn:agent_condition:tamper_sensor',
        'mrn:agent_condition:ralenti',
        'mrn:agent_condition:fuel_consumption_deviation',
        'mrn:agent_condition:fuel_charge',
        'mrn:agent_condition:generic_unauthorized_stop',
        'mrn:agent_condition:temperature',
        'mrn:agent_condition:multi_temperature',
        'mrn:agent_condition:generic_put_into_service',
        'mrn:agent_condition:generic_taken_out_of_service',
        'mrn:agent_condition:generic_still_detached',
        'mrn:agent_condition:generic_event_test',
        'mrn:agent_condition:generic_seat_passenger',
        'mrn:agent_condition:generic_delivery',
        'mrn:agent_condition:generic_sharped_turn',
        'mrn:agent_condition:generic_hard_brake',
        'mrn:agent_condition:generic_hard_acceleration',
        'mrn:agent_condition:engine_temperature',
        'mrn:agent_condition:excessive_rpm'
      ]
      const keys = []
      let isTheService = null
      this.allThings
        .filter(thing => thing.config.hasOwnProperty('services'))
        .forEach(thing => {
          const keyThing = Object.keys(thing.config.services)
          keyThing.forEach(element => {
            switch (element) {
              case 'mrn:service:panic_button':
                isTheService = keys.includes('mrn:agent_condition:panic_button')
                if (!isTheService) keys.push('mrn:agent_condition:panic_button')
                break
              case 'mrn:service:driver_door':
                isTheService = keys.includes('mrn:agent_condition:driver_door')
                if (!isTheService) keys.push('mrn:agent_condition:driver_door')
                isTheService = keys.includes(
                  'mrn:agent_condition:driver_door_normal'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:driver_door_normal')
                break
              case 'mrn:service:cargo_gate':
                isTheService = keys.includes('mrn:agent_condition:cargo_gate')
                if (!isTheService) keys.push('mrn:agent_condition:cargo_gate')
                isTheService = keys.includes(
                  'mrn:agent_condition:cargo_gate_normal'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:cargo_gate_normal')
                break
              case 'mrn:service:semi_detach':
                isTheService = keys.includes('mrn:agent_condition:semi_detach')
                if (!isTheService) keys.push('mrn:agent_condition:semi_detach')
                isTheService = keys.includes(
                  'mrn:agent_condition:semi_detach_normal'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:semi_detach_normal')
                break
              case 'mrn:service:tamper_sensor':
                isTheService = keys.includes(
                  'mrn:agent_condition:tamper_sensor'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:tamper_sensor')
                break
              case 'mrn:service:fuel_cut_off':
                isTheService = keys.includes('mrn:agent_condition:fuel_cut_off')
                if (!isTheService) keys.push('mrn:agent_condition:fuel_cut_off')
                break
              case 'mrn:service:telemetry':
                isTheService = keys.includes('mrn:agent_condition:ralenti')
                if (!isTheService) keys.push('mrn:agent_condition:ralenti')
                isTheService = keys.includes(
                  'mrn:agent_condition:fuel_consumption_deviation'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:fuel_consumption_deviation')
                isTheService = keys.includes('mrn:agent_condition:fuel_charge')
                if (!isTheService) keys.push('mrn:agent_condition:fuel_charge')
                isTheService = keys.includes(
                  'mrn:agent_condition:engine_temperature'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:engine_temperature')
                isTheService = keys.includes(
                  'mrn:agent_condition:excessive_rpm'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:excessive_rpm')
                break
              case 'mrn:service:car_transporter_lasso':
                isTheService = keys.includes(
                  'mrn:agent_condition:lasso_disconnected'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:lasso_disconnected')
                break
              case 'mrn:service:temperature_sensor':
                isTheService = keys.includes('mrn:agent_condition:temperature')
                if (!isTheService) keys.push('mrn:agent_condition:temperature')
                break
              case 'mrn:service:temperature_multi_sensor':
                isTheService = keys.includes(
                  'mrn:agent_condition:multi_temperature'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:multi_temperature')
                break
              case 'mrn:service:generic_unauthorized_stop':
                isTheService = keys.includes(
                  'mrn:agent_condition:generic_unauthorized_stop'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:generic_unauthorized_stop')
                break
              case 'mrn:service:generic_put_into_service':
                isTheService = keys.includes(
                  'mrn:agent_condition:generic_put_into_service'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:generic_put_into_service')
                break
              case 'mrn:service:generic_taken_out_of_service':
                isTheService = keys.includes(
                  'mrn:agent_condition:generic_taken_out_of_service'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:generic_taken_out_of_service')
                break
              case 'mrn:service:generic_still_detached':
                isTheService = keys.includes(
                  'mrn:agent_condition:generic_still_detached'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:generic_still_detached')
                break
              case 'mrn:service:generic_event_test':
                isTheService = keys.includes(
                  'mrn:agent_condition:generic_event_test'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:generic_event_test')
                break
              case 'mrn:service:generic_seat_passenger':
                isTheService = keys.includes(
                  'mrn:agent_condition:generic_seat_passenger'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:generic_seat_passenger')
                break
              case 'mrn:service:generic_delivery':
                isTheService = keys.includes(
                  'mrn:agent_condition:generic_delivery'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:generic_delivery')
                break
              case 'mrn:service:generic_sharped_turn':
                isTheService = keys.includes(
                  'mrn:agent_condition:generic_sharped_turn'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:generic_sharped_turn')
                break
              case 'mrn:service:generic_hard_brake':
                isTheService = keys.includes(
                  'mrn:agent_condition:generic_hard_brake'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:generic_hard_brake')
                break
              case 'mrn:service:generic_hard_acceleration':
                isTheService = keys.includes(
                  'mrn:agent_condition:generic_hard_acceleration'
                )
                if (!isTheService)
                  keys.push('mrn:agent_condition:generic_hard_acceleration')
                break
            }
          })
        })
      const quitServices = keysServices.filter(e => !keys.includes(e))

      return thing
        .filter(e => !quitServices.includes(e.id))
        .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
    },
    scheduling(e) {
      if (e.cron_spec) {
        e.cron_spec = e.cron_spec.map(cron => {
          const cronObj = {}
          const index = Object.keys(cron.value)
          for (const key in index) {
            cronObj[index[key]] = cron.value[key]
          }
          cron.value = cronObj
          return cron
        })
      }

      this.dataForm['scheduling'] = e
      if (e.cron_spec.length === 0) {
        delete this.dataForm['scheduling']
      }
    },
    getThingsList() {
      GlobalHelpers.getEntities({
        projection: 'id, info.label, type, config.services'
      }).then(response => {
        store.dispatch('things/setResponseError', false)
        if (response.length > 0) {
          this.allThings = response
          this.thingsLoading = false
        } else {
          // setear respuesta de no hay info para mostrar
        }
      })
    },
    async getAgents() {
      const { response } = await AgentsHelpers.getAgents()
      if (!response.hasOwnProperty('error')) {
        this.agents = response.args[0]
      }
    },

    selectAll() {
      this.$nextTick(() => {
        if (this.selectedAllThings) {
          this.selectedThings.forEach(element => {
            element.checked = false
          })
          this.selectedThings = []
          this.updateThings()
        } else {
          if (this.allThingsFiltered !== this.allThings) {
            this.selectedThings = this.allThingsFiltered
            this.selectedThings.forEach(element => {
              element.checked = true
            })
          } else {
            this.selectedThings = this.allThings
            this.selectedThings.forEach(element => {
              element.checked = true
            })
          }
          this.updateThings()
        }
      })
    },
    checkName() {
      const name = this.dataForm.label
      if (this.agents.length > 0) {
        const agents = this.agents
        for (let index = 0; index < agents.length; index++) {
          const element = agents[index]
          if (element.label === name) {
            this.repeatAgentName = element
            this.showDialog = true
            this.dialog.type = 'warning'
            this.dialog.text = i18n.t(
              'fleet_management.agents.create.errors.agent_match'
            )
            this.dialog.oneButtonDialog = true
            this.dialog.oneButtonText = i18n.t(
              'general.dialogComponent.acceptButtonText'
            )
            this.errorName = i18n.t(
              'fleet_management.agents.create.errors.name_duplicated'
            )
            this.cancelSubmit = true
            break
          } else this.errorName = ''
        }
      }
    },
    cancelDialog() {
      this.showDialog = false
      Object.assign(this.dialog, this.dialogDefault)
    },
    timeEmit(time) {
      this.dataForm.window = time
    },
    geofenceEmit(data, index) {
      const geofences = {}
      this.conditionsSelected[index].value = {}
      for (let i = 0; i < data.length; i++) {
        const element = data[i]
        const id = element.id
        const name = element.properties.name
        geofences[id] = name
        Object.assign(this.conditionsSelected[index].value, {
          [id]: name
        })
      }
    },
    speedEmit(speed, index) {
      Object.assign(this.conditionsSelected[index].value, {
        // eslint-disable-next-line @typescript-eslint/camelcase
        speed_limit: Number(speed)
      })
    },
    mainPowerEmit(mainPower, index) {
      Object.assign(this.conditionsSelected[index].value, {
        // eslint-disable-next-line @typescript-eslint/camelcase
        main_power_on: this.conditionsSelected[index].name.type
      })
    },
    fuelCutEmit(fuel, index) {
      Object.assign(this.conditionsSelected[index].value, {
        // eslint-disable-next-line @typescript-eslint/camelcase
        fuel_cut_off: this.conditionsSelected[index].name.type
      })
    },
    ignitionStateEmit(ignitionState, index) {
      Object.assign(this.conditionsSelected[index].value, {
        // eslint-disable-next-line @typescript-eslint/camelcase
        contact_on: this.conditionsSelected[index].name.type
      })
    },
    detentionEmit(detention, index) {
      Object.assign(
        this.conditionsSelected[index].value,
        this.conditionsSelected[index].name.type
      )
    },
    batteryLowEmit(battery, index) {
      Object.assign(this.conditionsSelected[index].value, {
        // eslint-disable-next-line @typescript-eslint/camelcase
        low_battery: Number(battery)
      })
    },
    ralentiRpmEmit(rpm, index) {
      Object.assign(this.conditionsSelected[index].value, {
        // eslint-disable-next-line @typescript-eslint/camelcase
        ralenti_rpm: Number(rpm)
      })
    },
    rpmExcessiveEmit(rpm, index) {
      Object.assign(this.conditionsSelected[index].value, {
        rpm_limit: Number(rpm)
      })
    },
    fuelConsumptionDeviationEmit(fuel, index) {
      Object.assign(this.conditionsSelected[index].value, {
        // eslint-disable-next-line @typescript-eslint/camelcase
        fuel_deviation: Number(fuel)
      })
    },
    fuelTankEmit(fuel, index) {
      Object.assign(this.conditionsSelected[index].value, {
        // eslint-disable-next-line @typescript-eslint/camelcase
        fuel_limit: Number(fuel)
      })
    },
    dueUndueEmit(dueUndue, index) {
      Object.assign(this.conditionsSelected[index].name, {
        alias: dueUndue,
        id: dueUndue
      })
    },
    addCondition() {
      firebaseServices.logEvent(
        firebaseServices.analytics,
        FirebaseTagNames.BTN_FLEET_MANAGEMENT_AGENT_COMBINED
      )

      this.conditionsSelected.push({
        name: {},
        agent: '',
        value: {}
      })
      // Calcular las opciones disponibles en base a la primer condicion
      this._availableConditions()
    },
    removeCondition(index) {
      this.conditionsSelected.splice(index, 1)
      this.availableConditions.splice(index, 1)
      this.conditionsForTimeComponent.splice(index, 1)
      this._availableConditions()
      if (
        !this.conditionsSelected.find(
          element => element.alias === 'mrn:agent_condition:ignition_off'
        )
      ) {
        this.contactOff = false
      }
    },
    waitAndSearchAnAgent() {
      // Espera 500ms y ejecuta la funcion checkName
      this.cancelSubmit = false
      clearTimeout(this.setTime)
      this.setTime = setTimeout(() => {
        this.checkName()
      }, 500)
    },
    _setAgent(val, index) {
      this.$set(this.conditionsSelected[index], 'name', val)
      this.$set(this.conditionsSelected[index], 'agent', val.component)
      //Dejo el value vacío para que reciba de los emits la info
      this.$set(this.conditionsSelected[index], 'value', {})
      this.conditionsForTimeComponent.splice(index, 1, val.id)
      this.contactOff = val.alias === 'mrn:agent_condition:ignition_off'
    },

    // se setean las condiciones disponibles dependiendo del archivo "conditions_config" que es inyectado por el server
    _setConditions() {
      const primaryConditions = Object.keys(conditions_config)
      for (let i = 0; i < primaryConditions.length; i++) {
        const condition = primaryConditions[i]

        for (let i = 0; i < this.allConditions.length; i++) {
          const element = this.allConditions[i]
          if (element.alias == condition) {
            this.conditionsList.push(element)
          }
        }
      }
    },
    _availableConditions() {
      //Función que retorna las posibilidades de combinación entre condiciones
      const arrLength = this.conditionsSelected.length
      let index
      //En caso que haya mas de 1 condición mi referencia es la última seteada.
      //De ahi el juego de valor para el indice
      if (arrLength > 1) index = arrLength - 2
      else index = arrLength - 1

      const obj = this.conditionsSelected[index]
      const alias = obj.name.alias
      const isCombinable = this._isCombinable(obj.name)
      if (isCombinable) {
        const tempArr = []
        const response = AgentsHelpers.getCombinations(alias)
        for (let i = 0; i < response.length; i++) {
          const alias = response[i]
          for (let i = 0; i < this.allConditions.length; i++) {
            const condition = this.allConditions[i]
            if (condition.alias == alias) {
              tempArr.push(condition)
            }
          }
        }
        this.$set(this.availableConditions, index + 1, tempArr)
      }
    },
    _isCombinable(val) {
      //Esta función retorna true o false en caso de que la condición sea combinable
      // y se encarga de habilitar o deshabilitar el boton 'añadir condición'
      let valueToReturn = false
      const alias = val.alias
      const response = AgentsHelpers.getCombinations(alias)
      if (response.length > 0) {
        this.isCombinable = true
        valueToReturn = true
      } else this.isCombinable = false
      return valueToReturn
    },
    onChange(val, index) {
      if (!val) return
      this.checkServiceForUndue(val.id)
      this.validityWindowInSecurity(val.id)
      this._setAgent(val, index)
      this._isCombinable(val)
    },

    removeAccents(string) {
      return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },

    filterNormalized(item, queryText, itemText) {
      const queryTextNormalized = this.removeAccents(queryText.toLowerCase())
      const itemTextNormaized = this.removeAccents(itemText.toLowerCase())

      const condsName = this.allConditions
        .map(conds => this.removeAccents(conds.name.toLowerCase()))
        .filter(item => item.includes(queryTextNormalized))
      return condsName.includes(itemTextNormaized)
    },

    clearConditions(entity) {
      if (entity.length == 0) {
        this.availableConditions[0] = this.allConditions
      }
    },

    updateThings() {
      firebaseServices.logEvent(
        firebaseServices.analytics,
        FirebaseTagNames.INP_FLEET_MANAGEMENT_AGENT_ADD_ENTITIES
      )

      const formThings = this.selectedThings

      const things = {}

      for (let index = 0; index < formThings.length; index++) {
        const element = formThings[index]
        const id = element.id
        const name = element.info.label
        things[id] = name
      }
      this.dataForm.things = Object.assign({}, things)
    },
    goBack() {
      this.$router.push({ name: 'Agents' })
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.submitLoading = true
        this.conditionsSelected.map(condition => {
          let conditionsObj
          const id = condition.name.id
          switch (id) {
            case 'mrn:agent_condition:speed_limit':
              conditionsObj = {
                [id]: { ...condition.value }
              }
              break
            case 'mrn:agent_condition:geofence':
              conditionsObj = {
                [id]: {
                  type: condition.name.type,
                  geofences: { ...condition.value }
                }
              }
              break
            case 'mrn:agent_condition:main_power':
              conditionsObj = {
                [id]: { ...condition.value }
              }
              break

            case 'mrn:agent_condition:fuel_cut_off':
              conditionsObj = {
                [id]: { ...condition.value }
              }
              break

            case 'mrn:agent_condition:no_report':
              conditionsObj = {
                [id]: condition.name.type
              }
              break
            case 'mrn:agent_condition:ignition':
              conditionsObj = {
                [id]: { ...condition.value }
              }
              break
            case 'mrn:agent_condition:detention':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:panic_button':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:lasso_disconnected':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:driver_door':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:driver_door_normal':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:cargo_gate':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:cargo_gate_normal':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:semi_detach':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:semi_detach_normal':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:tamper_sensor':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:movement_start':
              conditionsObj = {
                [id]: condition.value
              }
              break
            case 'mrn:agent_condition:low_battery':
              conditionsObj = {
                [id]: {
                  low_level: condition.value.low_battery
                }
              }
              break
            case 'mrn:agent_condition:ralenti':
              conditionsObj = {
                [id]: {
                  rpm_limit: condition.value.ralenti_rpm
                }
              }
              break
            case 'mrn:agent_condition:fuel_consumption_deviation':
              conditionsObj = {
                [id]: {
                  fuel_deviation: condition.value.fuel_deviation / 100
                }
              }
              break
            case 'mrn:agent_condition:fuel_charge':
              conditionsObj = {
                [id]: {
                  fuel_limit: condition.value.fuel_limit / 100
                }
              }
              break
            case 'mrn:agent_condition:temperature':
              conditionsObj = {
                [id]: {
                  min_temp: condition.value.min_temp + 0.0001,
                  max_temp: condition.value.max_temp + 0.0001
                }
              }
              break
            case 'mrn:agent_condition:multi_temperature':
              const inputTemps = condition.value || {}
              const sensorObject = {}
              Object.entries(inputTemps).forEach(([key, value]) => {
                if (value.min_temp != null && value.max_temp != null) {
                  sensorObject[key] = {
                    min_temp: parseFloat(value.min_temp) + 0.0001,
                    max_temp: parseFloat(value.max_temp) + 0.0001
                  }
                }
              })
              conditionsObj = { [id]: sensorObject }
              break
            case 'mrn:agent_condition:generic_unauthorized_stop':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:generic_put_into_service':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:generic_taken_out_of_service':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:generic_still_detached':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:generic_event_test':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:generic_seat_passenger':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:generic_delivery':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:generic_sharped_turn':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:generic_hard_brake':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:generic_hard_acceleration':
              conditionsObj = {
                [id]: {}
              }
              break
            case 'mrn:agent_condition:engine_temperature':
              conditionsObj = {
                [id]: {
                  max_temp: condition.value.max_temp + 0.0001
                }
              }
              break
            case 'mrn:agent_condition:excessive_rpm':
              conditionsObj = {
                [id]: {
                  rpm_limit: condition.value.rpm_limit
                }
              }
              break
            default:
              break
          }
          Object.assign(this.dataForm.conditions, conditionsObj)
        })
        let user_id = null
        if (this.selectedScope === 'Propio') {
          user_id = localStorage.getItem('user_id')
        }
        AgentsHelpers.createAgent(this.dataForm, user_id).then(
          async response => {
            this.submitLoading = false
            this.newAgentId = response.args[0].id
            this.newAgent = response.args[0]
            if (response.hasOwnProperty('error')) {
              this.showDialog = true
              this.dialog.type = 'error'
              switch (response.error) {
                case 'com.magenta.error.unexpected_error':
                  this.dialog.text = 'Algo salió mal, por favor reintente'
                  this.dialog.oneButtonDialog = true
                  this.dialog.oneButtonText = i18n.t(
                    'general.dialogComponent.acceptButtonText'
                  )
                  break
              }
            } else {
              this.$store.commit('events/setCurrentAgent', {
                currentAgent: this.newAgent
              })
              this.$refs.notificationsCreate.setAgentId(this.newAgentId)
              this.$refs.notificationsCreate.setAgent(this.newAgent)

              if (this.baseTagsChange)
                await this.$refs.tagsAgentThingRefs.submit()
              if (this.baseTagsPersonChange)
                await this.$refs.tagsPersonRefs.submit()

              await this.$refs.notificationsCreate.submit()

              this.showForm = false
            }
          }
        )
      }
    },
    securityCondition(val) {
      switch (val) {
        case 'mrn:agent_condition:panic_button':
          return 'Pánico'
        case 'mrn:agent_condition:lasso_disconnected':
          return 'Apertura de lazo'
        case 'mrn:agent_condition:driver_door':
        case 'mrn:agent_condition:driver_door_normal':
          return 'Apertura de puerta'
        case 'mrn:agent_condition:cargo_gate':
        case 'mrn:agent_condition:cargo_gate_normal':
          return 'Apertura de portón'
        case 'mrn:agent_condition:semi_detach':
        case 'mrn:agent_condition:semi_detach_normal':
          return 'Desenganche'
        case 'mrn:agent_condition:tamper_sensor':
          return 'Antivandálico vulnerado'
        case 'mrn:agent_condition:fuel_cut_off':
          return 'Combustible'
        default:
          return ''
      }
    },
    validityWindowInSecurity(val) {
      if (
        val === 'mrn:agent_condition:panic_button' ||
        val === 'mrn:agent_condition:driver_door' ||
        val === 'mrn:agent_condition:cargo_gate' ||
        val === 'mrn:agent_condition:semi_detach' ||
        val === 'mrn:agent_condition:tamper_sensor' ||
        val === 'mrn:agent_condition:lasso_disconnected'
      ) {
        delete this.dataForm.window
      } else {
        this.dataForm.window = 0
      }
    },
    movementEmit(movement) {
      this.conditionsSelected.map(agent => {
        if (agent.agent === 'Movement') {
          agent.value = movement
        }
      })
    },
    movementValid(valid) {
      this.movementValids = valid
    },
    tempSensorEmit(tempSensor) {
      this.conditionsSelected.map(agent => {
        if (agent.agent === 'TemperatureSensor') {
          agent.value = tempSensor
        }
      })
    },
    tempSensorMulti(tempSensor) {
      this.conditionsSelected.map(agent => {
        if (agent.agent === 'TemperatureMultiSensor') {
          agent.value = tempSensor
        }
      })
    },
    engineTempEmit(engineTemp) {
      this.conditionsSelected.map(agent => {
        if (agent.agent === 'EngineTemperature') {
          agent.value = engineTemp
        }
      })
    },
    temperatureValid(valid) {
      this.temperatureValids = valid
    },
    temperatureMultiValid(valid) {
      this.temperatureMultiValids = valid
    },
    engineTemperatureValid(valid) {
      this.engineTemperatureValids = valid
    },
    rpmExcessiveValid(valid) {
      this.rpmExcessiveValids = valid
    }
  },
  computed: {
    TagsHelpers() {
      return TagsHelpers
    },
    ...mapGetters('auth', ['connection']),
    ...mapGetters('events', ['getCurrentAgentTags']),
    ...mapGetters(['validationsTimeRestriction']),
    isConditionMovementStartOrLowBattery() {
      let found = false
      if (
        this.conditionsForTimeComponent.find(
          e =>
            e == 'mrn:agent_condition:movement_start' ||
            e == 'mrn:agent_condition:low_battery'
        )
      ) {
        found = true
      }
      return found
    },
    selectRules() {
      const isPowerOrIgnition = this.conditionsForTimeComponent.some(
        v =>
          v === 'mrn:agent_condition:ignition' ||
          v === 'mrn:agent_condition:main_power'
      )
      // armo array con los servicios que soporta las condicion
      const isSecurityConditionsEvents = this.conditionsForTimeComponent.map(
        v => {
          switch (v) {
            case 'mrn:agent_condition:panic_button':
              return 'mrn:service:panic_button'
            case 'mrn:agent_condition:driver_door':
            case 'mrn:agent_condition:driver_door_normal':
              return 'mrn:service:driver_door'
            case 'mrn:agent_condition:cargo_gate':
            case 'mrn:agent_condition:cargo_gate_normal':
              return 'mrn:service:cargo_gate'
            case 'mrn:agent_condition:semi_detach':
            case 'mrn:agent_condition:semi_detach_normal':
              return 'mrn:service:semi_detach'
            case 'mrn:agent_condition:tamper_sensor':
              return 'mrn:service:tamper_sensor'
            case 'mrn:agent_condition:fuel_cut_off':
              return 'mrn:service:fuel_cut_off'
            case 'mrn:agent_condition:lasso_disconnected':
              return 'mrn:service:car_transporter_lasso'
          }
        }
      )

      if (isPowerOrIgnition && this.selectedThings.length > 0) {
        const isVehicle = this.selectedThings.some(
          v => v.type !== 'mrn:thing:vehicle'
        )
        if (isVehicle)
          return [
            i18n.t('fleet_management.agents.create.errors.single_vehicles')
          ]
      }
      // creo array con los things que no soporta la condicion
      if (this.selectedThings.length > 0) {
        const isSecurity = this.selectedThings.map(e => {
          for (const key in isSecurityConditionsEvents) {
            if (!isSecurityConditionsEvents[key]) {
              break
            }
            if (
              !e.config.services ||
              !e.config.services?.[isSecurityConditionsEvents[key]] ||
              e.config.services?.[isSecurityConditionsEvents[key]]?.status ===
                'suspended'
            ) {
              return {
                name: e.info.label,
                condition: isSecurityConditionsEvents[key]
              }
            }
          }
        })
        const result = isSecurity.filter(e => e) // quita si existe undefined
        // unifica las array en un objeto para retornar el rules con los things no soportados
        if (result.length > 0) {
          const rulesResult = { label: '', condition: '', length: 0 }
          for (const key in result) {
            rulesResult.label =
              rulesResult.label + ' ' + result[key].name.toString() + ','
            rulesResult.length++
            rulesResult.condition = this.securityCondition(
              result[key].condition
            )
          }

          return [
            `la${rulesResult.length > 0 ? 's' : ''} entidad${
              rulesResult.length > 0 ? 'es' : ''
            } ${rulesResult.label} ${i18n.t(
              'fleet_management.agents.create.errors.service_not_contracted'
            )}`
          ]
        } else {
        }
      }
      return []
    },
    validityForm() {
      return (
        this.dataForm.label.length > 1 &&
        this.conditionsForTimeComponent.length > 0 &&
        this.movementValids &&
        this.temperatureValids &&
        this.temperatureMultiValids &&
        this.engineTemperatureValids &&
        this.rpmExcessiveValids
      )
    },
    selectedAllThings() {
      return this.selectedThings.length === this.allThingsFiltered.length
    },
    selectedSomeThings() {
      return this.selectedThings.length > 0 && !this.selectedAllThings
    },
    icon() {
      if (this.selectedAllThings) return 'mdi-close-box'
      if (this.selectedSomeThings) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    scopeMessage() {
      let text = ''
      let color = ''
      if (this.selectedScope === 'Corporativo') {
        text = i18n.t(
          'fleet_management.agents.create.labels.create_agent_corporate'
        )
        color = 'grey'
      } else {
        text = i18n.t('fleet_management.agents.create.labels.create_agent_own')
        color = '#ffa100b8'
      }
      return { text, color }
    },
    allThingsFiltered() {
      let filteredThings = this.allThings.filter(
        thing =>
          thing.config.services?.['mrn:service:live_tracking']?.status &&
          thing.config.services?.['mrn:service:live_tracking']?.status !==
            'inactive' &&
          thing.config.services?.['mrn:service:live_tracking']?.status !==
            'suspended' &&
          thing.config?.['service_plan']?.status !== 'inactive'
      )

      const conditionSelected = this.conditionsSelected[0].name.name
      if (this.lowBattery) {
        filteredThings = filteredThings.filter(
          thing => thing.type === 'mrn:thing:flex'
        )
      } else if (
        this.isRalenti ||
        this.isFuelConsumptionDeviation ||
        this.isFuelCharge ||
        this.isEngineTemperature ||
        this.isRpmExcessive
      ) {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:telemetry'
          )
        )
      } else if (this.isLassoDisconnected) {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:car_transporter_lasso'
          )
        )
      } else if (this.isTemperatureSensor) {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:temperature_sensor'
          )
        )
      } else if (this.isTemperatureMultiSensor) {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:temperature_multi_sensor'
          )
        )
      } else if (conditionSelected === 'Antivandálico vulnerado') {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:anti_jamming'
          )
        )
      } else if (conditionSelected === 'Apertura de puerta') {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:driver_door'
          )
        )
      } else if (conditionSelected === 'Apertura de portón') {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:cargo_gate'
          )
        )
      } else if (
        conditionSelected === 'Combustible Cortado' ||
        conditionSelected === 'Combustible restablecido'
      ) {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:fuel_cut_off'
          )
        )
      } else if (
        conditionSelected === 'Conexión de Bateria' ||
        conditionSelected === 'Desconexión de Bateria'
      ) {
        filteredThings = filteredThings.filter(
          thing => thing.type === 'mrn:thing:vehicle'
        )
      } else if (conditionSelected === 'Desenganche') {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:semi_detach'
          )
        )
      } else if (
        conditionSelected === 'En Contacto' ||
        conditionSelected === 'Sin Contacto'
      ) {
        filteredThings = filteredThings.filter(
          thing => thing.type === 'mrn:thing:vehicle'
        )
      } else if (conditionSelected === 'Pánico') {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:panic_button'
          )
        )
      } else if (conditionSelected === 'Parada No Autorizada') {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:generic_unauthorized_stop'
          )
        )
      } else if (conditionSelected === 'Puesta en Servicio') {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:generic_put_into_service'
          )
        )
      } else if (conditionSelected === 'Quita de Servicio') {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:generic_taken_out_of_service'
          )
        )
      } else if (conditionSelected === 'Todavía Desenganchado') {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:generic_still_detached'
          )
        )
      } else if (conditionSelected === 'Evento de prueba') {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:generic_event_test'
          )
        )
      } else if (conditionSelected === 'Pasajero detectado') {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:generic_seat_passenger'
          )
        )
      } else if (conditionSelected === 'Entrega') {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:generic_delivery'
          )
        )
      } else if (conditionSelected === 'Giro Brusco') {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:generic_sharped_turn'
          )
        )
      } else if (conditionSelected === 'Frenada Brusca') {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:generic_hard_brake'
          )
        )
      } else if (conditionSelected === 'Aceleración Brusca') {
        filteredThings = filteredThings.filter(thing =>
          Object.keys(thing.config.services).find(
            service => service === 'mrn:service:generic_hard_acceleration'
          )
        )
      } else {
        filteredThings = this.allThings.filter(
          thing =>
            thing.config.services?.['mrn:service:live_tracking'] &&
            thing.config.services?.['mrn:service:live_tracking']?.status !==
              'inactive' &&
            thing.config.services?.['mrn:service:live_tracking']?.status !==
              'suspended' &&
            thing.config?.['service_plan']?.status !== 'inactive'
        )
      }
      for (let index = 0; index < filteredThings.length; index++) {
        filteredThings[index]['domElementId'] = `idEventosEntidad${index}`
      }
      return filteredThings
    },
    lowBattery() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:low_battery'
      )
    },
    isRalenti() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:ralenti'
      )
    },
    isEngineTemperature() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:engine_temperature'
      )
    },
    isRpmExcessive() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:excessive_rpm'
      )
    },
    isTemperatureSensor() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:temperature'
      )
    },
    isTemperatureMultiSensor() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:multi_temperature'
      )
    },
    isFuelConsumptionDeviation() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:fuel_consumption_deviation'
      )
    },
    isFuelCharge() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:fuel_charge'
      )
    },
    isLassoDisconnected() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:lasso_disconnected'
      )
    },
    isAntiJamming() {
      return this.conditionsForTimeComponent.find(
        thing => thing === 'mrn:agent_condition:anti_jamming'
      )
    }
  },

  watch: {
    connection: {
      handler(newVal) {
        if (newVal.session.isOpen) {
          this._setConditions()
          this.getThingsList()
          this.getAgents()
        }
      },
      deep: true
    }
  },

  created() {
    if (this.connection.session.isOpen) {
      this._setConditions()
      this.getThingsList()
      this.getAgents()
    }
    this.availableConditions.push(this.conditionsList)
  },

  mounted() {
    this.amountConditions = 2
  }
}
</script>

<style lang="scss" scoped>
.orange--text {
  color: var(--orange) !important;
}
.dialog-attention {
  border: 2px solid var(--orange);
}
.dropdown-element-style {
  color: #2b2b2b;
  font-family: Lato, sans-serif;
  font-size: 13px;
  width: 100%;
}
</style>
